import type { EntityType } from '../types/EntityType';

const PARTIES_SYSTEM_ENTITY_TYPE_NAME = 'Parties';

/**
 * Identifies the seeded system entity type that backs the Parties pages.
 * Both `is_system` and the name are required: a client can create a custom type
 * called "Parties", and that one is a browse-like-any-other entity type.
 */
export const isPartiesSystemEntityType = (entityType: EntityType) =>
  entityType.is_system && entityType.name === PARTIES_SYSTEM_ENTITY_TYPE_NAME;
